module.exports = __webpack_public_path__ + "0b65f1b58057a95ab0f1b46f13c0a9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-cosmetic@2x.png
// module id = 1743
// module chunks = 0